import mixpanelClient from "mixpanel-browser";

let initialized = false;

const getMixpanel = () => {
  const token = import.meta.env.VITE_MIXPANEL_TOKEN;
  if (!token) return null;

  if (!initialized) {
    // Match our explicit event collection without adding automatic tracking or replay.
    mixpanelClient.init(token, {
      autocapture: false,
      track_pageview: false,
      record_sessions_percent: 0,
    });
    initialized = true;
  }

  return mixpanelClient;
};

// Replace Segment's browser context; the SDK already supplies OS/device properties.
const getBrowserProperties = () => ({
  locale: navigator.language,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  mobile:
    /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1),
});

export const mixpanel = {
  identify(directoryUuid: string | undefined) {
    const client = getMixpanel();
    if (!client) return;
    const previousUuid = client.get_property("$user_id");
    // Do not merge different accounts into the same browser identity.
    if (previousUuid && previousUuid !== directoryUuid) client.reset();
    if (directoryUuid && previousUuid !== directoryUuid) client.identify(directoryUuid);
  },
  track(eventName: string, properties: object) {
    getMixpanel()?.track(eventName, { ...getBrowserProperties(), ...properties });
  },
  page(properties: object) {
    // Preserve the Viewed event and page context from Segment's destination mapping.
    getMixpanel()?.track("Viewed", {
      ...getBrowserProperties(),
      path: window.location.pathname,
      url: window.location.href,
      search: window.location.search,
      title: document.title,
      referrer: document.referrer,
      ...properties,
    });
  },
  reset() {
    if (initialized) mixpanelClient.reset();
  },
};
